import PropTypes from "prop-types";
import React from "react";
import signature from "../../../../assets/img/cachet.png";
import { LOGGED_USER } from "../../../../variables/constants";
import { frenchDateOnly, splitNameStringForPrintingAttestation, numeroPoliceAffichage } from "../../../../variables/functions";
import AntidateBadge from "./AntidateBadge";
import DuplicataStamp from "./DuplicataStamp";
import { resolveAttestationDriver } from "./attestationDriver";

const AttestationMotoToPrint = React.forwardRef((props, ref) => {
  // Nom imprimé : mono-engin → assuré par défaut ; flotte → conducteur ; interrupteur = preferSouscripteur.
  const d = resolveAttestationDriver({ contrat: props?.contrat, engin: props?.engin, preferSouscripteur: props?.preferSouscripteur });
  const driverNom = d.nom;
  const driverPrenom = d.prenom;
  const driverNomComplet = d.nomComplet;
  const driverAdresse = d.adresse;
  const driverContact = d.contact;
  const driverProfession = d.profession;
  return (
    <div
      ref={ref}
      className="position-relative"
      style={{
        height: 400,
        width: 1080,
        // Décale TOUT le contenu de l'attestation vers le haut à l'impression (ajuster cette valeur
        // pour monter/descendre l'ensemble).
        top: -8,
        // Décale TOUT le contenu vers la gauche (valeur négative) ou la droite (positive).
        left: -60,
        // Texte bien noir et gras pour ressortir nettement sur le papier d'impression.
        color: "#000",
        fontWeight: 700,
        WebkitTextStroke: "0.35px #000",
        WebkitPrintColorAdjust: "exact",
        printColorAdjust: "exact",
      }}
    >
      <AntidateBadge
        contrat={props.contrat}
        variant="inset"
        inset={{ box: 120, banner: 175, edge: 48, pos: 36, off: 38, fontSize: 8, line: 12, padV: 3 }}
      />
      <DuplicataStamp contrat={props.contrat} fontSize={22} panels={4} />
      <div className="row">
        <div
          className="col"
          style={{ position: "relative", left: "76px", top: "260px" }}
        >
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "20px",
              marginTop: "63px",
              fontSize: "12px",
            }}
          >
            <b>
              {driverNom}{" "}
              {driverPrenom || ""}{" "}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "20px",
              marginTop: "78px",
              fontSize: "12px",
            }}
          >
            <b>{driverContact}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "75px",
              marginTop: "95px",
              fontSize: "12px",
            }}
          >
            <b>
              {numeroPoliceAffichage(props.contrat)}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "37px",
              marginTop: "110px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "125px",
              marginTop: "110px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "115px",
              marginTop: "126px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "112px",
              marginTop: "143px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "78px",
              marginTop: "160px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "80px",
              marginTop: "176px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || ""}</b>
          </h6>
        </div>
        <div
          className="col"
          style={{ position: "relative", left: "81px", top: "260px" }}
        >
          <h6
            className=""
            style={{
              position: "absolute",
              marginLeft: "-40px",
              marginTop: "98px",
              fontSize: "12px",
            }}
          >
            <b>
              {numeroPoliceAffichage(props.contrat)}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-81px",
              marginTop: "115px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "7px",
              marginTop: "115px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-3px",
              marginTop: "132px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-4px",
              marginTop: "150px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-39px",
              marginTop: "165px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-50px",
              marginTop: "181px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "10px",
              marginTop: "198px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.usage || "_"}</b>
          </h6>
        </div>
        <div
          className="col"
          style={{ position: "relative", left: "86px", top: "262px" }}
        >
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-82px",
              marginTop: "20px",
              fontSize: "12px",
            }}
          >
            <b>
              {
                splitNameStringForPrintingAttestation(
                  `${driverNomComplet}`,
                  21,
                ).firstLine
              }
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-217px",
              marginTop: "46px",
              fontSize: "12px",
            }}
          >
            <b>
              {
                splitNameStringForPrintingAttestation(
                  `${driverNomComplet}`,
                  21,
                ).secondLine
              }{" "}
              {driverAdresse}{" "}
              {driverContact}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-150px",
              marginTop: "64px",
              fontSize: "12px",
            }}
          >
            <b>{driverProfession}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-153px",
              marginTop: "81px",
              fontSize: "12px",
            }}
          >
            <b>
              {numeroPoliceAffichage(props.contrat)}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-180px",
              marginTop: "107px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-65px",
              marginTop: "107px",
              fontSize: "12px",
            }}
          >
            <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-120px",
              marginTop: "128px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-122px",
              marginTop: "145px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-155px",
              marginTop: "162px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.numeroChassis || ""}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-135px",
              marginTop: "180px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.genre || "-"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-55px",
              marginTop: "197px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.usage || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-182px",
              marginTop: "245px",
              fontSize: "12px",
            }}
          >
            <b>App. Terrestre</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-32px",
              marginTop: "245px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.marque || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "-100px",
              marginTop: "260px",
              fontSize: "12px",
            }}
          >
            <b>{props.engin?.immatriculation || "_"}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "193px",
            }}
          >
            {props.contrat?.organisme?.typeOrganisme === "POOL" && (
              <img style={{ width: "60%" }} src={signature} />
            )}
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "253px",
              fontSize: "11px",
            }}
          >
            Imprimée à {props.contrat?.producteur?.agence?.ville} le {props?.contrat?.dateImpressionAttestation ? frenchDateOnly(props?.contrat?.dateImpressionAttestation?.split("T")[0]) : frenchDateOnly(props?.contrat.createdAt?.split("T")[0])}
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "105px",
              marginTop: "273px",
              fontSize: "11px",
            }}
          >
            par {props.contrat?.producteur?.personne?.nom} {props.contrat?.producteur?.personne?.prenom}
          </h6>
        </div>
      </div>

    </div>
  );
});
AttestationMotoToPrint.propTypes = {
  contrat: PropTypes.object,
  engin: PropTypes.object,
};
AttestationMotoToPrint.displayName = "Attestation Moto";
export default AttestationMotoToPrint;
